import { ArrowUpRight } from "lucide-react";
import { BUSINESSES, CONNECTORS } from "@/data/content";
import SectionBadge from "@/components/site/SectionBadge";

export default function ExploreBlezzings() {
  return (
    <section
      id="explore"
      data-testid="explore-section"
      className="pt-16 md:pt-20 pb-24 md:pb-32 bg-[#F2F2F2]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        {/* Intro */}
        <SectionBadge label="Explore BLEZZINGS" />
        <div className="mt-6 grid grid-cols-12 gap-6 md:gap-10 mb-14 md:mb-20">
          <div className="col-span-12 md:col-span-6">
            <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
              Connecting Ideas, Capital, Capability &amp; Impact.
            </h1>
          </div>
          <div className="col-span-12 md:col-span-6 space-y-5 text-zinc-700 leading-relaxed">
            <p>
              The BLEZZINGS ecosystem is designed to foster innovation, fund
              ambition, and drive systemic impact.
            </p>
            <p className="font-serif-display text-xl italic text-black">
              Grow. Learn. Publish. Talk. Build. Invest. Impact.
            </p>
          </div>
        </div>

        {/* Business cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {BUSINESSES.map((b, i) => (
            <a
              key={b.slug}
              href={`/businesses/${b.slug}`}
              data-testid={`business-card-${b.slug}`}
              className="group relative bg-white border border-black/10 flex flex-col hover:border-black hover:-translate-y-1 transition-all duration-500 overflow-hidden"
            >
              {/* Image */}
              {b.image && (
                <div className="relative aspect-[16/10] w-full overflow-hidden bg-zinc-100">
                  <img
                    src={b.image}
                    alt={b.imageAlt || b.name}
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover img-edit transition-transform duration-700 group-hover:scale-[1.04]"
                  />
                  <div className="absolute inset-0 bg-black/5 group-hover:bg-black/0 transition-colors duration-500" />
                </div>
              )}

              <div className="p-8 md:p-9 flex flex-col justify-between flex-1">
                <div>
                  <div className="text-[11px] font-semibold tracking-[0.28em] uppercase text-zinc-500">
                    {String(i + 1).padStart(2, "0")} · {b.descriptor}
                  </div>
                  <h3 className="font-serif-display font-bold text-2xl md:text-[26px] leading-tight text-black mt-4">
                    {b.name}
                  </h3>
                  <p className="mt-4 text-[15px] text-zinc-600 leading-relaxed">
                    {b.blurb}
                  </p>
                  <p className="mt-5 font-serif-display italic text-black text-lg">
                    {b.keywords}
                  </p>
                </div>
                <div className="mt-8 pt-6 border-t border-black/10 flex items-center justify-between">
                  <span className="text-sm font-medium text-black">
                    Explore {b.name.replace("BLEZZINGS ", "").replace("BLEZZ ", "")}
                  </span>
                  <ArrowUpRight className="h-5 w-5 text-black transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </div>
              </div>
              <span aria-hidden className="absolute left-0 bottom-0 h-[3px] w-0 bg-black transition-all duration-500 group-hover:w-full" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
